import React, {FC, ReactNode} from 'react';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {PaperProps} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {Theme as DefaultTheme} from '@material-ui/core/styles/createMuiTheme';
import {getDirectionStyles} from '../../utils/ThemeUtils';

import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export interface GlobalSelectButtonProps extends PaperProps {
    children: ReactNode;
    startAdornment?: ReactNode;
    endAdornment?: ReactNode;
    open?: boolean;
}

const useStyles = makeStyles<DefaultTheme, GlobalSelectButtonProps, string>(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',

        width: '100%',
        height: '67px',

        cursor: 'pointer',
        padding: theme.spacing(0, 3),
        margin: theme.spacing(2, 0),
        backgroundColor: props =>
            // @ts-ignore
            props.open ? theme.palette.background.overlays : theme.palette.background.paper,
        border: 'none',

        '&> span': {
            fontSize: '16px !important',
            margin: getDirectionStyles(theme.direction)(
                theme.spacing(0, 0, 0, 4),
                theme.spacing(0, 4, 0, 0)
            )
        },
        // Start adornment icon size
        '& svg:first-of-type': {
            fontSize: '1.9rem'
        },
        // Expand icon
        '& svg:last-of-type': {
            fontSize: '1.2rem'
        },

        [theme.breakpoints.up('flg')]: {
            '&> span': {
                fontSize: '18px !important'
            }
        },

        [theme.breakpoints.up('lg')]: {
            '&> span': {
                fontSize: '22px !important'
            }
        }
    }
}));

const GlobalSelectButton: FC<GlobalSelectButtonProps> = (props: GlobalSelectButtonProps) => {
    const {children, startAdornment, endAdornment, open, ...restProps} = props;

    const classes = useStyles(props);

    const handleKeyDown = event => {
        if (event.key === 'Enter') {
            props.onClick(event);
        }
    };

    return (
        <Paper
            aria-label="button"
            tabIndex={0}
            onKeyDown={handleKeyDown}
            {...restProps}
            classes={classes}>
            {startAdornment}

            <Typography noWrap variant="body1" component="span">
                {children}
            </Typography>

            <Box ml="auto" />
            {endAdornment}
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Paper>
    );
};

export default GlobalSelectButton;
